<template>

  <div class="price" :class="pClass">
    <div class="goods-price" v-if="price>0||(price<=0&&credit<=0)">
      <div class="price-box">
        <em>¥</em><b>{{price}}</b>
        <div class="qi" v-if="hasConfigSKU">起</div>
        <i v-if="proposedPrice>0">¥{{proposedPrice}}</i>
      </div>
    </div>
    <div class="goods-credit" v-if="credit>0">
      <div v-if="price>0">
        <span>{{credit}}<b>{{creditName}}</b></span><span class="qi" v-if="hasConfigSKU">起</span>
      </div>
      <div class="credit-bold" v-else>
        <span>{{credit}}<b>{{creditName}}</b></span><span class="qi" v-if="hasConfigSKU">起</span>
      </div>

    </div>
  </div>
</template>
<script>
import { getStorage } from '@/utils/wxuser';
export default {
  data() {
    return {
      creditName: getStorage('creditName') || '积分'
    };
  },
  props: ["price", "credit", "proposedPrice", "pClass", "notShowPriceUnit", "hasConfigSKU"],

};
</script>
<style lang="less" scoped>
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");
.price {
  min-height: 1.173333rem;
  &.activity {
    margin-top: 0.2rem;
  }
  &.activity2,
  &.activity,
  &.activity3 {
    margin-left: -0.16rem;
    .goods-price {
      .price-box {
        b {
          font-size: 22px;
        }
      }
    }
    .goods-credit {
      margin-left: -0.16rem;
      
    }
  }
  &.activity3 {
    min-height: 0.8rem;
  }
  &.goods {
    min-height: auto;
    .goods-credit {
      .credit-bold {
         margin-top: -0.133333rem;
      }
    }
  }
  .goods-price {
    .price-box {
      em {
        font-size: 12px;
        font-family: TimesNewRomanPS-ItalicMT;
        margin-right: 2px;
        color: @color-price;
      }
      b {
        font-weight: bold;
        font-size: 25px;
        font-family: TimesNewRomanPS-BoldItalicMT;
        color: @color-price;
      }
      .qi {
        display: inline-block;
        color: @color-price;
        font-size: 12px;
      }
      i {
        font-family: TimesNewRomanPS-ItalicMT;
        font-size: 12px;
        color: #999999;
        text-decoration: line-through;
      }
    }
  }
  .goods-credit {
    margin-top: 0.133333rem;
    font-family: TimesNewRomanPS-ItalicMT;
    font-size: 14px;
    color: @color-theme;
    b {
      font-size: 10px;
    }
    .qi {
      color: @color-theme;
      font-size: 10px;
    }
    .credit-bold {
      font-family: TimesNewRomanPS-BoldItalicMT;
      color: @color-price;
      font-size: 25px;
      b {
        color: @color-price;
        font-size: 14px;
      }
      .qi {
        color: @color-price;
        font-size: 14px;
      }
    }
  }
}
// .price {
//   font-size: 12px;
//   display: inline-block;
//   color: #999999;
//   margin-top: 0.133333rem;
//   min-height: 0.666667rem;
//   .qi {
//     display: inline-block;
//     font-style: normal;
//     color: @color-price;
//     font-size: 10px;

//     line-height: 18px;
//     color: @color-price;
//   }
//   &.goods {
//     margin: 0;
//     .free {
//       b {
//         font-size: 20px;
//         line-height: 30px;
//       }
//     }
//     span {
//       b {
//         font-size: 30px;
//       }
//     }
//     .credit {
//       line-height: 18px;
//       &.big {
//         span {
//           font-size: 30px;
//           line-height: 26px;
//         }
//       }
//     }
//     i {
//       line-height: 18px;
//     }
//     .proposedPrice {
//       line-height: 18px;
//     }
//   }
//   &.activity {
//     margin-left: -0.266667rem;
//     font-size: 12px;
//     color: #999999;
//     height: 0.746667rem;

//     margin-top: 0.16rem;
//     display: inline-block;
//   }
//   &.activity2 {
//     margin-left: -0.266667rem;
//     font-size: 12px;
//     color: #999999;
//     height: 0.746667rem;

//     margin-top: 0.08rem;
//     display: inline-block;
//   }
//   &.activity3 {
//     margin-left: -0.373333rem;
//     font-size: 12px;
//     color: #999999;
//     height: 0.746667rem;

//     margin-top: 0rem;
//     display: inline-block;
//   }
//   i {
//     font-style: italic;
//     line-height: 16px;
//   }
//   &.small {
//     margin-top: 0;
//     .free {
//       b {
//         font-size: 16px;
//       }
//     }
//     i {
//       line-height: 18px;
//       font-size: 16px;
//     }
//     b {
//       font-size: 20px;
//     }
//     .credit {
//       line-height: 15px;
//       b {
//         font-size: 12px;
//       }
//     }
//   }
//   .cur-price {
//     display: inline-block;
//     font-family: TimesNewRomanPS-ItalicMT;
//   }
//   span.proposedPrice {
//     line-height: 16px;
//     text-decoration: line-through;
//     color: #999999;
//     font-size: 12px;
//     font-style: italic;
//   }
//   .credit {
//     display: inline-block;
//     font-style: normal;
//     color: @color-price;
//     font-weight: bold;
//     font-size: 10px;
//     line-height: 16px;
//     &.big {
//       span {
//         font-size: 25px;
//         line-height: 22px;
//       }
//       b {
//         font-size: 12px;
//       }
//     }

//     span {
//       font-family: TimesNewRomanPS-BoldItalicMT;
//       font-size: 14px;
//       display: inline-block;
//     }
//   }
//   span {
//     color: @color-price;
//     i {
//       text-decoration: none;
//     }
//     b {
//       text-decoration: none;
//       font-family: TimesNewRomanPS-BoldItalicMT;
//       font-size: 25px;
//     }
//   }
//   .free {
//     b {
//       font-size: 18px;
//     }
//   }
// }
</style>


// WEBPACK FOOTER //
// src/components/price.vue